import React from 'react';
import './Calendar.css';

const Calendar = () => {
  return (
    <span className="calendar_container">
      <div className="component_img" />

      <h1>Calendar</h1>

      <div className="calendar_titles">
        <p>Region 20 All</p>
        <p>Band</p>
        <p>Choir</p>
        <p>Orchestra</p>
        <p>Mariachi</p>
      </div>
      <div className="calendar_body">
        <iframe
          src="https://www.google.com/calendar/embed?showTabs=0&amp;showTz=0&amp;height=600&amp;wkst=1&amp;bgcolor=%23FFFFFF&amp;src=lt8faemo09pf3l9fq6clgbd2t8%40group.calendar.google.com&amp;color=%2323164E&amp;src=uilregion20music%40gmail.com&amp;color=%232F6309&amp;src=dlolf5bi4mifhb464s5okvs33k%40group.calendar.google.com&amp;color=%23B1365F&amp;src=pl80mi8in06khdjtir21ncesig%40group.calendar.google.com&amp;color=%23711616&amp;src=lrmopv4f8rnc2bddv39fso9ddk%40group.calendar.google.com&amp;color=%23853104&amp;ctz=America%2FChicago"
          className="calendar"
          frameBorder="0"
          scrolling="no"
          title="Region Calendar"
        />
      </div>
    </span>
  );
};

export default Calendar;



// WEBPACK FOOTER //
// ./src/Components/Calendar/Calendar.js